@for (item of config().availableStatus; track item.statusId) {
    <button
        class="resetStyles group-btn"
        (click)="onSelect(item, $event)"
        [ngClass]="{
            active: item.statusId === config().status
        }"
        [disabled]="!item.canSwitch"
        libTooltip
        [tooltip]="!item.canSwitch ? 'Mark a Final Estimate as “Selected” to change to this status' : null"
        [useParentForPositioning]="true"
    >
        <span>{{ item.statusName }}</span>
    </button>
}
